const devEnvironment = {
    project2BaseUrl:'http://localhost:2002'
}

const prodEnvironment = {
    project2BaseUrl:'https://nth-rest-api.niit.mindex.cloud'
}

const testEnvironment = {
    project2BaseUrl:'https://dev-nth-rest-api.niit.mindex.cloud'
}

export let environment;

if(process.env.REACT_APP_ENV === 'production'){
    environment = prodEnvironment
}else if(process.env.REACT_APP_ENV === 'test'){
    environment = testEnvironment
}else{
    environment = devEnvironment
}